<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="categoryId"
            search-url="/category/onSearchAllStatus?categoryTypeCode=OFFICE_LOCATION&sortField=categoryId&"
            create-url="/category/save"
            delete-url="/category/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
        >
        </c-search-form>
        <office-location-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :pondAreas="pondAreas"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import OfficeLocationCreate from "./OfficeLocationCreate.vue";
import axios from "axios";
import { cateContants } from "@/constants";

export default {
    name: "office-location-list",
    components: {OfficeLocationCreate, CSearchForm },
    data: () => {
        return {
            formName: "Danh sách địa điểm",
            formCreateName: "Thêm mới",
            category: null,
            visibleCreateDialog: false,
            timeReload: 0,
            pondAreas: [],
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "categoryName",
                    text: "Tên",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                },
                {
                    value: "parentId",
                    text: "Khu nuôi",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: 'parentId',
                    items: [],
                    itemText: "categoryCode",
                    itemValue: "categoryId",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: cateContants.materialStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    sortable: false,
                    compound: true,
                    width: "120px",
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        this.getAreas();
    },

    methods: {
        openCreateDialog: function (item = null) {
            if (item == null) {
                this.formCreateName = 'Thêm mới';
                this.visibleCreateDialog = true;
            } else {
                this.category = item;
                this.formCreateName = 'Cập nhật';
                this.visibleCreateDialog = true;
            }
        },
        closeCreateDialog: function () {
            this.category = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
        getAreas() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=PONDAREA", {status: 1}
            )
            .then(
                (data) => {
                    if (data.length > 0) {
                        this.pondAreas = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "parentId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                }
            );
        }
    },

    destroyed() {},
};
</script>
